import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import { Link } from 'react-router-dom';

class Request extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			request: {
				shop_job: {},
				job_scope: {},
				shop_job_pi: {},
				shop_job_rch: {},
				PHOTOS: []
			},
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadRequest();
	}

	loadRequest(event) {
		var self = this;

		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/Jobtrack/GetRequest',
			data: { 
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				requestid: null
			}
		}).done(function (data) {
			if (data.Success) {
				self.mergeState({ request: data.Data, renderKey: self.state.renderKey + 1 });
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
		
	onChange(accessor, value) {
		var request = this.copyObject(this.state.request);
		this.setByAccessor(request, accessor, value);
		
		this.setState({
			request: request,
			renderKey: this.state.renderKey + 1
		});
	}
	
	validateRequest(event, columns, data) {
		return this.validate(columns, data);
	}

	onSubmit(event) {
		var self = this;
		var i;
		var filesAreWellFormed = true;
		
		// examine files property to make sure it is well formed
		if (this.state.request.PHOTOS instanceof FileList && this.state.request.PHOTOS.length > 0) {
			for (i = 0; i < this.state.request.PHOTOS.length; i++) {
				if (!(this.state.request.PHOTOS[i] && this.state.request.PHOTOS[i].name)) {
					filesAreWellFormed = false;
					break;
				}
			}
		}
		
		// if there is a file
		if (filesAreWellFormed) {
			// copy request data, except PHOTOS
			var request = {
				shop_job: this.copyObject(this.state.request.shop_job),
				job_scope: this.copyObject(this.state.request.job_scope),
				shop_job_pi: this.copyObject(this.state.request.shop_job_pi),
				shop_job_rch: this.copyObject(this.state.request.shop_job_rch)
			};
			
			// if there is a speedtype, add a percent
			if (!this.isEmpty(request.shop_job_rch.SPEEDTYPE)) {
				request.shop_job_rch.PERCENT = 100;
			}
			
			// Create an object of formData
			const formData = new FormData();

			// add the token to the formData
			formData.append('__RequestVerificationToken', this.props.user.antiForgeryToken);
			
			// create form data for request object
			var requestData = this.createHiddenFormData({ request: request });
			
			// add the request to the FormData
			for (i = 0; i < requestData.length; i++) {
				formData.append(requestData[i].name, requestData[i].value);
			}
		
			// if files are attached
			if (this.state.request.PHOTOS instanceof FileList && this.state.request.PHOTOS.length > 0) {
				// for each file
				for (i = 0; i < this.state.request.PHOTOS.length; i++) {
					// add the file information
					formData.append('photos[' + i + ']', this.state.request.PHOTOS[i], this.state.request.PHOTOS[i].name);
				}
			}
			
			this.ajax({
				type: 'POST',
				url: this.getConfig().host + '/Jobtrack/UpdateRequest',
				data: formData,
				contentType: false,
				processData: false
			}).done(function (data) {
				if (data.Success) {
					self.showConfirmation(() => <>
						<span style={{ fontWeight: 'bold', fontSize: '18px' }}>Thank You!</span><br />
						<br />
						Please check your email - a confirmation email has been sent to you.<br />
						<br />
						You can check the status of your request on the&nbsp;
						<Link to='/Jobtrack/Requests'>Building Management Requests Status Page</Link>	
					</>);
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		} else {
			self.showAlert('Bad File Information', 'Files could not be read. Please contact John Borland at jborland@berkeley.edu for assistance.');
		}
	}
	
	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
						  New Work Request
						</div>
						<ul>
						  <li>Not to be used for emergency contact.</li>
						  <li>For any relocation, dismantling, and/or set-up needed, please contact chem_request@berkeley.edu for an assessment. Services may be provided on a recharge basis by the College of Chemistry Shops or Campus Facilities Services.</li>
						  <li>Please provide as much information as possible to help us process your request, including where applicable:</li>
						  <ul>
							<li>Building(s)</li>
							<li>Room Number(s)</li>
							<li>IDs/locations of fume hoods, sinks, meters, or anything else involved in the request</li>
						  </ul>
						</ul>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={requestColumns} data={this.state.request}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							validate={(event, columns, data) => this.validateRequest(event, columns, data)}
							onSubmit={(event) => this.onSubmit(event)}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								<Button id="save" variant="warning" type="submit" className="float-end">Save</Button>
							  </Col>
							</Form.Group>							
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

const requestColumns = [
	{ Header: 'Name', accessor: 'shop_job.NAME', row: 0, col: 0 },
	{ Header: 'Email', accessor: 'shop_job.EMAIL', row: 0, col: 1 },
	{ Header: 'Phone', accessor: 'shop_job.PHONE', row: 0, col: 2 },
	{ Header: 'Date', accessor: 'shop_job.START_DATE', type: 'date', row: 1, col: 0, editable: false },
	{ Header: 'Lab Group', accessor: 'shop_job_pi.PI_ROLE', type: 'select', row: 1, col: 1,
		options: { value: 'ROLE_ID', label: 'PI_NAME', entity: 'RECHARGES.SHOPS_PI_SELECT_VW', order: 'PI_NAME' }},
	{ Header: 'Forward To', accessor: 'shop_job.SHOP_ID', type: 'select', row: 1, col: 2, required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.SHOP_SELECT_VW' }},
	{ Header: 'Title', accessor: 'shop_job.JOB_REF', row: 2, col: 0, colwidth: 12 },
	{ Header: 'Description', accessor: 'shop_job.JOB_DESC', type: 'textarea', row: 3, col: 0, colwidth: 12 },
	{ Header: "<div style='margin-bottom: 8px; margin-top: -8px;'>If this request is urgent and you would like it to be completed in-house, provide speedtype</div>", accessor: 'shop_job_rch.SPEEDTYPE', row: 4, col: 0, colwidth: 12 },
	{ Header: 'Photos', accessor: 'PHOTOS', type: 'files', row: 5, col: 1, colwidth: 6 }
];

export default withRouter(Request);
